import { z } from "zod";
import { UserRole, UserSchema } from "../schemas";
export const TeamGrantSchema = z.object({
  email: z
    .string()
    .trim()
    .email()
    .max(254)
    .transform((value) => value.toLowerCase()),
  fullName: z.string().trim().min(1).max(200),
  role: UserRole,
});
export const TeamRevisionSchema = z
  .string()
  .min(1)
  .max(128)
  .refine((value) => Number.isFinite(Date.parse(value)));
export const TeamListSchema = z
  .object({ data: z.array(UserSchema) })
  .superRefine((value, ctx) => {
    const ids = new Set<string>();
    value.data.forEach((member, index) => {
      if (ids.has(member.id))
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Duplicate member",
          path: ["data", index, "id"],
        });
      ids.add(member.id);
    });
  });
export const TeamGrantResultSchema = z.object({
  data: UserSchema,
  invitationDelivery: z.literal("NOT_SENT"),
});
export type TeamGrant = z.infer<typeof TeamGrantSchema>;
